export default __webpack_public_path__ + "static/media/outcess9.84e142fc.jpeg";